module.exports = __webpack_public_path__ + "img/replay-button.fb42aab8.png";